import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignInComponent } from './sign-in/sign-in.component';
import { AuthGuard } from './_shared/guards/auth.guard';
import { AuthenticatedLayoutComponent } from './_shared/components/authenticated-layout/authenticated-layout.component';
import { SetComponent } from './set/set.component';

const signedInRoutes: Routes = [
  {
    path: 'dashboard',
    // canActivate: [DashboardGuard],
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'users',
    // canActivateChild: [UserGuard],
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
  },
  
  {
    path: 'support',
    // canActivateChild: [SupportGuard],
    loadChildren: () => import('./support/support.module').then(m => m.SupportModule)
  }
];

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'signin' },
  {
    path: 'signin',
    component: SignInComponent
  },
  { 
    path: 'credentials', 
    loadChildren: () => import('./credentials/credentials.module').then(m => m.CredentialsModule) 
  },
  {
    path: 'reset/activate',
    component: SetComponent
  },
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    // canActivate: [AuthGuard],
    children: signedInRoutes
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
